import React, { FunctionComponent } from 'react';
import { Card } from 'rs-emd-ui-atoms';
import { RecentlyViewedItem } from '../../../../../../generated/graphql';
import { getLabel } from '../../../../helpers/html.utils';
import { ILabel } from '../../../../models/common/label.model';
import { BrandListingItem } from '../../../user/my-account/product-listing/brand-listing-item/brand-listing-item-component';
import ProductListing from '../../../user/my-account/product-listing/product-listing-component';
import sharedStyles from '../recently-viewed-shared.module.scss';

type RecentlyViewedBrandsProps = {
  labels?: ILabel[];
  data?: RecentlyViewedItem[] | null;
  onClickItemCallback?: (brand: RecentlyViewedItem) => void;
};

export const RecentlyViewedBrands: FunctionComponent<RecentlyViewedBrandsProps> = (props: RecentlyViewedBrandsProps) => {
  return (
    <Card className={`${sharedStyles['overview-card']} ${sharedStyles['list-container']}`} padding={false}>
      <ProductListing
        title={getLabel(props.labels, 'recently_viewed_brands')}
        tabletWidth='17.6rem'
        elt={BrandListingItem}
        items={props.data?.slice(0, 6) ?? undefined}
        {...props}
      />
    </Card>
  );
};
